import { MainMenu, Widget } from 'rangeConfig/@types';
import ProductList from 'rangeConfig/shared/widgets/ProductList';
import ProductSwiper from 'rangeConfig/shared/widgets/ProductSwiper';
import withProducts from 'rangeConfig/shared/widgets/withProducts';
import sectionsProductListConfig from './productListConfig';
import platform from 'rangeConfig/shared/utils/platform';
import {
  depthFilter,
  heightFilterWithSizeLabel,
  widthFilter
} from 'rangeConfig/shared/filters/configFilters';
import ProductSortFilterWidget from 'rangeConfig/shared/widgets/ProductSortFilterWidget';
import withInlineMessage from 'rangeConfig/shared/widgets/withInlineMessage';
import CategoryAdditionalInlineMessage from 'components/ProductSidebar/CategoryWidget/CategoryAdditionalInlineMessage';

const widgets = {
  desktop: [
    {
      id: 'cross-brace-inline-message',
      component: withInlineMessage(
        'storageone.ivarSectionsInlineMessageDescription',
        false,
        'storageone.ivarSectionsInlineMessageTitle'
      )(CategoryAdditionalInlineMessage)
    },
    {
      id: 'frontListProductFilter',
      component: () => ProductSortFilterWidget()
    } as Widget,
    { id: 'sections-product-list', component: withProducts(ProductList, sectionsProductListConfig) }
  ],
  mobile: [
    {
      id: 'sections-product-list',
      component: withProducts(ProductSwiper, sectionsProductListConfig),
      title: 'storageone.productListSectionsTitle'
    }
  ]
};

const mainMenu: MainMenu = {
  menuTitle: 'storageone.productListSectionsTitle',
  behaviors: {
    productGroupEntered: [],
    productGroupExited: []
  },
  filters: [heightFilterWithSizeLabel, widthFilter, depthFilter],
  widgets: widgets[platform]
};

export default mainMenu;
